/**
 * TZ+ artwork.
 *
 * CDN-hosted rather than bundled, matching every other tour asset (TourModalSlot, TourBannerSlot,
 * habitat/media.ts): `src/assets` holds fonts, icons and svgs, never photography.
 *
 * The whole upper band of both welcome modals is ONE image — photograph, gradient, Toronto Zoo Plus
 * lockup and headline are all baked in, so none of them exist as DOM. That is why the headline copy
 * survives here only as alt text: a screen reader has nothing else to read.
 */
const BASE = 'https://zoolife.tv/assets/guidedTour/tzplus';

/** Full hero band for the desktop welcome modal. */
export const TZ_PLUS_HERO_DESKTOP_SRC = `${BASE}/welcome-desktop.webp`;

/** Full hero band for the phone card — a different crop, not the desktop one scaled. */
export const TZ_PLUS_HERO_MOBILE_SRC = `${BASE}/welcome-mobile.webp`;
